export default {
  backgroundColor: "#121239",
  textStyle: {},
  tooltip: {
    axisPointer: {
      lineStyle: {
        color: "#FFFFFF",
      },
    },
  },
  categoryAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: "#07070B",
      },
    },
    axisTick: {
      show: true,
      alignWithLabel: true,
      lineStyle: {
        color: "#07070B",
      },
    },
    axisLabel: {
      show: true,
      color: "#C1C1CA",
    },
  },
  valueAxis: {
    splitLine: {
      show: true,
      lineStyle: {
        color: "#07070B",
      },
    },
    axisLine: {
      show: false,
    },
    axisLabel: {
      show: true,
      color: "#C1C1CA",
    },
  },
};
